// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 36) return "static/js/8931c89b1ce02c4faa58.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"b93b7ea05e00544cd518","138":"6a95d2f628f99605f982","139":"ed6b9488eea29a4d3720"}[chunkId] + ".chunk.js";
};